import { createSafeContext } from '@/package';

import type { VueronSprintContextValue } from './type';

const VueronSprintContext = createSafeContext<VueronSprintContextValue>(
  {} as VueronSprintContextValue,
  'VueronSprintContext',
);

export default VueronSprintContext;
